import dayjs from "dayjs";

// Workaround to store a date without time, because JS dates always contain the time
export type DateWithoutTime = string;

export const formatDateShort = (date: Date | string) => dayjs(date).format("DD.MM.YYYY");
